import styled from '../../../styled';
const Container = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;

  > div {
    word-break: break-word;
  }

  .checkboxColumn {
    width: 2rem;
    flex-grow: 0;
  }

  ${({ applyCustomStyles }) => applyCustomStyles && applyCustomStyles()}
`;
export default Container;
//# sourceMappingURL=Container.js.map